module.exports = __webpack_public_path__ + "img/dialog_survey.a18e7bd2.svg";